<template>
  <v-container fluid>
    <v-container fluid>
      <v-expansion-panel v-model="panel" expand>
        <v-expansion-panel-content class="mycustomExpansionPanel">
          <template v-slot:actions>
            <v-icon large color="primary">$vuetify.icons.expand</v-icon>
          </template>
          <template v-slot:header>
            <div>
              <v-icon color="primary">search</v-icon>
              <span class="pl-2 subheading">Custom Search Panel</span>
            </div>
          </template>
          <v-layout row wrap align-center>
            <v-flex>
              <v-card class="px-3">
                <v-layout row wrap align-center class="py-3">
                  <v-flex md12>
                    <v-autocomplete
                      v-model="currentExam"
                      :items="getExamMasterList"
                      item-text="exam_display_name"
                      :item-value="[]"
                      label="Select Exam"
                      data-vv-name="exam_name"
                      :error-messages="errors.collect('id')"
                      required
                      prepend-icon="subject"
                      v-on:change="SetCurrentExam"
                    ></v-autocomplete>
                  </v-flex>
                  <!-- <v-flex md3>
                    <v-select
                      v-model="getProbableSchema.degree_group_code"
                      :items="getCollegeDegreeWiseDegreeGroup"
                      item-text="degree_group_name"
                      item-value="degree_group_code"
                      label="Select Degree Group"
                      data-vv-name="degree_group_code"
                      :error-messages="errors.collect('degree_group_code')"
                      required
                      prepend-icon="subject"
                    ></v-select>
                  </v-flex>
                  <v-flex md3 v-if="getProbableSchema.degree_code!=1">
                    <v-select
                      v-model="getProbableSchema.subject_code"
                      :items="getCollegeDegreeGroupWiseSubject"
                      item-text="subject_name"
                      item-value="subject_code"
                      label="Select Subject"
                      data-vv-name="subject_code"
                      :error-messages="errors.collect('subject_code')"
                      required
                      prepend-icon="subject"
                    ></v-select>
                  </v-flex>-->
                  <v-flex xs12 sm12 md12 style="margin-top:40px;">
                    <v-layout justify-center row fill-height align-center>
                      <v-btn color="primary" large @click="searchList()"
                        >Search</v-btn
                      >
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-container>
    <!-- <v-dialog v-model="admitCardDialogStatus" fullscreen>
      <v-toolbar dark color="light-blue darken-3" class="mt-1">
        <v-toolbar-title>AdmitCard info</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-card flat color="light-blue darken-3" class="mr-5">
            <v-layout row fill-height align-center justify-center>
              Current Center &nbsp; :&nbsp;
              ({{ currentSubject.center_code }}){{
              currentSubject.center_name
              }}
            </v-layout>
          </v-card>
          <v-btn dark flat @click="close">Close</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card style="background-color: white;">
        <admitCardCountByPaper
          :dialogStatus.sync="admitCardDialogStatus"
          :currentSubject="currentSubject"
        ></admitCardCountByPaper>
      </v-card>
    </v-dialog>-->
    <v-container fluid>
      <v-card color="white">
        <v-layout row>
          <v-card
            flat
            class="margin-auto"
            v-if="getAdmitCardDataBySubject.length > 0"
          >
            <!-- <v-badge left overlap>
              <template v-slot:badge>
                <v-btn
                  round
                  color="primary"
                  fab
                  small
                  style="margin-top: -1.5em;"
                  class="elevation-0"
                  v-if="pagination.totalItems"
                  >{{ pagination.totalItems }}</v-btn
                >
              </template>
            </v-badge> -->
            <br />
            <h3 style="padding-left:10px">Admit Card By Subject</h3>
            <hr />
            <h2 class="text-center mt-2">Download Available</h2>
            <v-card-text>
              <!-- <table class="table text-center">
              
                <tbody>     
                  <tr
                    v-for="(item, index) in getAdmitCardDataBySubject"
                    :key="index"
                  >
                    <td>
                      <v-flex md4>
                      <v-chip>
                        <v-avatar class="teal" text-color="white">
                          <h4 class="color-white">
                            <h4 class="color-white">
                              {{
                                item.student_count
                              }}
                            </h4>
                          </h4>
                        </v-avatar>
                        <h3>[{{item.subject_code}}] {{item.subject_name}}</h3>
                      </v-chip>
                      </v-flex>
                    </td>
                    <td>
                      <table style="margin-left: -11px; margin-right: -11px;margin-top: -11px;">
                            <thead>
                                <tr style="height: 5px;width: 100%;">
                                    <th v-for="items in getadmitInstallmentsDataSet.data" :key="item.id"
                                        style="font-size: 12px; border: none; height: 30px;">
                                        {{ items.title }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                              <tr style="margin-left:20px;">
                                  <td v-for="items in getadmitInstallmentsDataSet.data" :key="item.id" style="border: 1px solid #fffffffc;">
                                      
                                      <v-tooltip right>
                                          <template v-slot:activator="{ on }">
                                              <v-btn
                                                  color="primary"
                                                  small
                                                  dark
                                                  fab
                                                  v-on="on"
                                                  @click="downloadAdmit(item, items.installment_no)"
                                              >
                                                  
                                                  <v-icon center dark>cloud_download</v-icon>
                                              </v-btn>
                                          </template>
                                          <span>Download Admit Card</span>
                                      </v-tooltip>

                                  
                                      <v-tooltip right>
                                          <template v-slot:activator="{ on }">
                                              <v-btn
                                                  color="primary"
                                                  small
                                                  dark
                                                  fab
                                                  v-on="on"
                                                  @click="downloadAttendanceSheet(item, items.installment_no)"
                                              >
                                                  <v-icon center dark>cloud_download</v-icon>
                                              </v-btn>
                                          </template>
                                          <span>Download Attendance Sheet</span>
                                      </v-tooltip>

                                      
                                      <v-tooltip right>
                                          <template v-slot:activator="{ on }">
                                              <v-btn
                                                  color="primary"
                                                  small
                                                  dark
                                                  fab
                                                  v-on="on"
                                                  @click="downLoadrollDescriptive(item, items.installment_no)"
                                              >
                                                  
                                                  <v-icon center dark>cloud_download</v-icon>
                                              </v-btn>
                                          </template>
                                          <span>Download Descriptive Roll Sheet</span>
                                      </v-tooltip>
                                  </td>
                              </tr>
                            </tbody>
                        </table>
                    </td>
                  </tr>
                </tbody>
              </table> -->
              <template>
                <v-data-table
                  :headers="headers"
                  :items="getAdmitCardDataBySubject"
                  class="elevation-1"
                  hide-actions
                >
                  <template v-slot:items="props">
                    <td>{{ props.index + 1 }}</td>
                    <td class="text-xs-left">
                      {{ props.item.student_count }}/{{
                        props.item.subject_code
                      }}
                      - {{ props.item.subject_name }}
                    </td>
                    <td class="text-xs-center">
                      <table
                        style="margin-left: -11px; margin-right: -11px;margin-top: -4px;"
                      >
                        <thead>
                          <tr style="height: 5px;width: 100%;">
                            <th
                              v-for="items in getadmitInstallmentsDataSet.data"
                              :key="items.id"
                              style="font-size: 12px; border: none; height: 30px;border: 2px solid #000;"
                            >
                              {{ items.title }}
                              <span style="font-weight: bold;"
                                >({{ formatDate(items.start_date) }} -
                                {{ formatDate(items.end_date) }})</span
                              >
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td
                              v-for="items in getadmitInstallmentsDataSet.data"
                              style="border: 1px solid #fffffffc;"
                            >
                              <span
                                v-for="itemsData in props.item.installments"
                              >
                                <span v-if="itemsData.total_students != 0">
                                  <!-- Tooltip for Admit Card -->
                                  <v-tooltip right>
                                    <template v-slot:activator="{ on }">
                                      <v-btn
                                        v-if="
                                          items.installment_no ==
                                            itemsData.installment_no
                                        "
                                        color="primary"
                                        small
                                        v-on="on"
                                        @click="
                                          downloadAdmit(
                                            props.item,
                                            items.installment_no
                                          )
                                        "
                                      >
                                        Admit (

                                        <span
                                          v-if="
                                            items.installment_no ==
                                              itemsData.installment_no
                                          "
                                          >{{ itemsData.total_students }}</span
                                        >

                                        )
                                        <v-icon right dark
                                          >cloud_download</v-icon
                                        >
                                      </v-btn>
                                    </template>
                                    <span>Download Admit Card</span>
                                  </v-tooltip>

                                  <!-- Tooltip for Attendance Sheet -->
                                  <v-tooltip right>
                                    <template v-slot:activator="{ on }">
                                      <v-btn
                                        v-if="
                                          items.installment_no ==
                                            itemsData.installment_no
                                        "
                                        color="primary"
                                        small
                                        dark
                                        v-on="on"
                                        @click="
                                          downloadAttendanceSheet(
                                            props.item,
                                            items.installment_no
                                          )
                                        "
                                      >
                                        Att. sheet
                                        <v-icon right dark
                                          >cloud_download</v-icon
                                        >
                                      </v-btn>
                                    </template>
                                    <span>Download Attendance Sheet</span>
                                  </v-tooltip>

                                  <!-- Tooltip for Descriptive Roll Sheet -->
                                  <v-tooltip right>
                                    <template v-slot:activator="{ on }">
                                      <v-btn
                                        v-if="
                                          items.installment_no ==
                                            itemsData.installment_no
                                        "
                                        color="primary"
                                        small
                                        dark
                                        v-on="on"
                                        @click="
                                          downLoadrollDescriptive(
                                            props.item,
                                            items.installment_no
                                          )
                                        "
                                      >
                                        DRS
                                        <v-icon right dark
                                          >cloud_download</v-icon
                                        >
                                      </v-btn>
                                    </template>
                                    <span>Download Descriptive Roll Sheet</span>
                                  </v-tooltip>
                                </span>
                                <span
                                  v-if="
                                    itemsData.total_students == 0 &&
                                      items.installment_no ==
                                        itemsData.installment_no
                                  "
                                >
                                  No Admit Card Available
                                </span>
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </template>
                </v-data-table>
              </template>
            </v-card-text>
          </v-card>
          <v-card v-else class="margin-auto">
            <v-card-text
              ><v-flex md12>
                <v-alert :value="true" color="warning">
                  No download available. Select your exam and click on SEARCH
                  button
                </v-alert>
              </v-flex></v-card-text
            >
          </v-card>
        </v-layout>
      </v-card>

      <!-- <v-data-table
        class="elevation-1"
        :headers="headers"
        :items="getAdmitCardDataBySubject"
        :loading="loading"
        :total-items="pagination.totalItems"
        :pagination.sync="pagination"
        :rows-per-page-items="pagination.rowsPerPageItems"
      >
        <template v-slot:items="props">
          <td>{{ props.index + 1 }}</td>
          <td class="text-xs" style="padding: 0 0px; !important">
            <v-chip color="transparent"
              >({{ props.item.exam_code }}) {{ props.item.exam_name }}</v-chip
            >
          </td>
          <td class="text-xs display-4" style="padding: 0 0px; !important">
            <v-chip color="transparent"
              >({{ props.item.college_code }})
              {{ props.item.college_name }}</v-chip
            >
          </td>
          <td class="text-xs-left">
            <v-btn small @click="viewAdmitCardColDetails(props.item)"
              >({{ props.item.subject_code }})
              {{ props.item.subject_name }}</v-btn
            >
          </td>

          <td class="text-xs">{{ props.item.year }}</td>
          <td class="text-xs-center">{{ props.item.student_count }}</td>
          <td class="justify-center text-xs-center">
            <v-layout row>
              <v-btn small @click="downloadAdmit(props.item)">Admit card</v-btn>
              <v-btn small @click="downLoadrollDescriptive(props.item)"
                >Descriptive Roll Sheet</v-btn
              >
              <v-btn small @click="downloadAttendanceSheet(props.item)"
                >attendance Sheet</v-btn
              >
            </v-layout>
          </td>
        </template>
      </v-data-table> -->
    </v-container>

    <!-- Special Admit Card Download -->
    <v-container fluid>
      <v-layout row>
        <v-flex>
          <v-card color="white">
            <v-card
              flat
              style="padding:10px;"
              v-if="getIndividualAdmitCardDownload.length"
            >
              <br />
              <h3>Individual Admit Card</h3>
              <!-- {{ college }} -->
              <!-- <br /> -->
              <template>
                <v-data-table
                  :headers="indivdualHeaders"
                  :items="getIndividualAdmitCardDownload"
                  class="elevation-1"
                >
                  <template v-slot:items="props">
                    <tr
                      v-for="(item, index) in props.item"
                      :key="index"
                      style="text-align: center;"
                    >
                      <td>{{ item.reg_no }}</td>
                      <td>
                        <v-btn
                          fab
                          color="primary"
                          small
                          dark
                          @click="downloadIndividualAdmit(item.admit_card_url)"
                        >
                          <v-icon center dark style="font-size:26px"
                            >cloud_download</v-icon
                          >
                        </v-btn>
                      </td>
                      <td>
                        <v-btn
                          fab
                          small
                          color="primary"
                          class="white--text"
                          v-bind="attrs"
                          v-on="on"
                          @click="downAttSheet(item.reg_no)"
                        >
                          <v-icon center dark style="font-size:26px"
                            >cloud_download</v-icon
                          >
                        </v-btn>
                      </td>
                      <td>
                        <v-btn
                          fab
                          small
                          color="primary"
                          class="white--text"
                          v-bind="attrs"
                          v-on="on"
                          @click="downLoadrollDescriptive_single(item.reg_no)"
                        >
                          <v-icon center dark style="font-size:26px"
                            >cloud_download</v-icon
                          >
                        </v-btn>
                      </td>
                    </tr>
                  </template>
                  <template v-slot:no-data>
                    <v-alert :value="true" color="error" icon="warning">
                      Sorry, nothing to display here :(
                    </v-alert>
                  </template>
                </v-data-table>
              </template>

              <!-- <v-card-text> -->
              <!-- <template>
                <v-table class="table text-center">
                  <thead>
                    <tr>
                      <th class="text-center">
                        Registration
                      </th>
                      <th class="text-center">
                        Admit Card
                      </th>
                      <th class="text-center">
                        Attandance Sheet
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in getIndividualAdmitCardDownload"
                      :key="index"
                    >
                      <td
                        v-for="(item2, index2) in item"
                        :key="index2 + '-' + index"
                         style="padding:10px;"
                      >
                      {{ item2.reg_no }}
                        
                      </td>
                      <td style="padding:10px;"> 
                        <v-flex md4>
                          <div class="text-xs-center">
                            <v-btn
                              round
                              color="primary"
                              medium
                              dark
                              class="w-250"
                              @click="
                                downloadIndividualAdmit(item2.admit_card_url)
                              "
                              style="font-size:12px"
                            >
                              Admit Card - {{ item2.reg_no }}
                              <v-icon right dark>cloud_download</v-icon>
                            </v-btn>
                          </div>
                        </v-flex>
                      </td>
                      <td style="padding:10px;">
                        <v-flex md4>
                          <div class="text-xs-center">
                            <v-btn
                              round
                              color="primary"
                              medium
                              dark
                              class="w-250"
                              @click="
                                downloadIndividualAdmit(item2.admit_card_url)
                              "
                              style="font-size:12px"
                            >
                              Admit Card - {{ item2.reg_no }}
                              <v-icon right dark>cloud_download</v-icon>
                            </v-btn>
                          </div>
                        </v-flex>
                      </td>
                    </tr>
                  </tbody>
                </v-table>
                </template> -->
              <!-- </v-card-text> -->
            </v-card>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <!-- close Special Admit Admit Card  -->
  </v-container>
</template>
<script>
import commonGet from "../../mixin/common_getters_mixin";
import ClgCommonGet from "@/mixin/college_common_getters_mixin";
import commonExamYear from "../../mixin/exam_year_watch_mixin";
// import admitCardCountByPaper from "@/components/admitCard/admitCardCountByPaper.vue";
export default {
  props: ["dialogStatus", "currentCollege"],
  mixins: [commonGet, commonExamYear, ClgCommonGet],
  components: {
    // admitCardCountByPaper
  },
  data() {
    return {
      panel: [true],
      admitCardDialogStatus: false,
      currentExam: {},
      currentItem: {},
      currentSubject: {},
      pagination: {
        rowsPerPage: 100,
        rowsPerPageItems: [50, 100, { text: "All", value: -1 }],
      },
      search: "",
      sl_count: 0,
      loading: false,
      searchParam: {},
      expand: false,
      headers: [
        { text: "SL.", align: "left", value: "id", sortable: false },
        { text: "Subject code & Nmae", value: "subject_code", sortable: false },
        { text: "Download", align: "center", value: "view", sortable: false },
      ],

      indivdualHeaders: [
        {
          text: "Registration No",
          align: "center",
          sortable: false,
          value: "name",
        },
        { text: "Admit Card", sortable: false, align: "center" },
        { text: "Attandance Sheet", sortable: false, align: "center" },
        { text: "Descriptive Roll Sheet", sortable: false, align: "center" },
      ],
    };
  },
  computed: {
    college() {
      return this.$store.getters.getAuthCollege;
    },
    getAdmitCardDataBySubject() {
      return this.$store.getters.getAdmitCardDataBySubject;
    },
    getIndividualAdmitCardDownload() {
      return this.$store.getters.getIndividualAdmitCardDownload;
    },
    getadmitInstallmentsDataSet() {
      return this.$store.getters.getAdmitCardInstallmentData;
    },
  },

  created() {
    this.$store.dispatch("getCollegeExamMasterList").then((response) => {
      // console.log(response.data);
    });
    // this.$store.commit("SET_LOGGEDIN_EXAM", {
    //   code: 3302
    // });
    // this.$store.commit("SET_LOGGEDIN_YEAR", {
    //   year: 2017
    // });
    //this.$store.commit("SET_EXAM_INITIATE_ID", 63);
    this.searchParam.exam_initiate_id = this.getExamInitiateId;
    this.searchParam.exam_year = this.getLoggedInYear.year;
    this.searchParam.exam_code = this.getLoggedInExam.code;
    this.searchParam.college_code = this.college.college_code;
    // this.$store.dispatch("fetchAdmitCardDataBySubject", this.searchParam);
  },

  methods: {
    fetchAdmitInstallmentDatalist() {
      let peram = {};
      peram.exam_initiate_id = this.getExamInitiateId;
      peram.exam_code = this.getLoggedInExam.code;
      peram.exam_year = this.getLoggedInYear.year;
      peram.college_code = this.searchParam.college_code;
      console.log("This is Load Data", peram);
      this.loading = true;
      this.$store.dispatch("fetchAdmitInstallmentData", peram).then(() => {
        this.loading = false;
      });
    },
    downAttSheet(reg) {
      let centerParam = {};
      centerParam.exam_initiate_id = this.getExamInitiateId;
      centerParam.exam_code = this.getLoggedInExam.code;
      centerParam.year = this.getLoggedInYear.year;
      centerParam.reg_no = reg;
      centerParam.college_code = this.college.college_code;
      console.log(
        "Tanvir! this is for download ind att sheet from Coll_p",
        centerParam
      );

      this.$store
        .dispatch("downloadExamWiseAttendanceSheetAtCenter2", centerParam)
        .then((result) => {
          if (!result) throw new Error("Empty response from server.");

          const blob = new Blob([result], { type: "application/pdf" });
          const url = URL.createObjectURL(blob);

          const link = document.createElement("a");
          link.href = url;
          link.download = `${reg}_att-signed.pdf`;

          document.body.appendChild(link);
          link.click();

          // Clean up
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error("Tanvir! Download failed ❌", error);
        });
    },
    downLoadrollDescriptive_single(reg) {
      //console.log("pr item", item);
      //return false;
      let param = {};
      param.college_code = this.college.college_code;
      param.reg_no = reg;
      param.exam_initiate_id = this.getExamInitiateId;
      param.exam_code = this.getLoggedInExam.code;
      param.year = this.getLoggedInYear.year;

      this.$store
        .dispatch("examWiseDescriptiveRollSheet2", param)
        .then((result) => {
          const blob = new Blob([result], { type: "application/pdf" });

          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = `${reg}_att-signed.pdf`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error("Tanvir! Download failed", error);
        });
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based in JS
      const year = String(date.getFullYear()).slice(-2); // Get the last two digits of the year
      return `${day}-${month}-${year}`;
    },
    getParam() {
      let param = {};
      param.college_code = this.college.college_code;
      param.center_code = this.currentCollege.center_code;
      param.exam_initiate_id = this.currentCollege.exam_initiate_id;
      param.exam_code = this.currentCollege.exam_code;
      param.year = this.currentCollege.year;
      return param;
    },
    setLimit() {
      const { sortBy, descending, page, rowsPerPage } = this.pagination;
      this.searchParam.page = page;
      this.searchParam.limit = rowsPerPage;
      this.searchParam.sortBy = sortBy;
      this.searchParam.search = this.search;
    },
    downloadIndividualAdmit(url) {
      var fileLink = document.createElement("a");
      fileLink.href = url;
      console.log(url);
      // fileLink.setAttribute("download", file_name);
      fileLink.setAttribute("target", "_blank");
      document.body.appendChild(fileLink);
      fileLink.click();
    },
    downloadAdmit(item, inst_no) {
      console.log("Tanvir! This is item", item);
      const param = {
        exam_code: item.exam_code,
        subject_code: item.subject_code,
        exam_year: item.year,
        college_code: item.college_code,
        module_name: "College",
        adm_installment_no: inst_no,
      };

      this.$store
        .dispatch("downloadAdmitCollegewiseCollegePanel2", param)
        .then((result) => {
          const blob = new Blob([result], { type: "application/pdf" });

          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `${item.exam_code}_${item.year}_${item.college_code}_${item.subject_code}-signed.pdf`
          );

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error("Tanvir! Download failed", error);
        });
    },
    downloadAttendanceSheet(item, inst_no) {
      console.log("Tanvir This is College Items", item);
      let param = {};
      param.college_code = item.college_code;
      param.center_code = item.center_code;
      param.subject_code = item.subject_code;
      param.exam_initiate_id = item.exam_initiate_id;
      param.exam_code = item.exam_code;
      param.year = item.year;
      param.adm_installment_no = inst_no;
      this.$store
        .dispatch("downloadExamWiseAttendanceSheetCollegePanel2", param)
        .then((result) => {
          const blob = new Blob([result], { type: "application/pdf" });

          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `${item.exam_code}_${item.year}_${item.college_code}_att-signed.pdf`
          );
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error("Tanvir! Download failed", error);
        });
    },

    downLoadrollDescriptive(item, inst_no) {
      let param = {};
      param.college_code = item.college_code;
      param.center_code = item.center_code;
      param.subject_code = item.subject_code;
      param.exam_initiate_id = item.exam_initiate_id;
      param.exam_code = item.exam_code;
      param.year = item.year;
      param.adm_installment_no = inst_no;

      this.$store
        .dispatch("downloadExamWiseDescriptiveRollSheet2", param)
        .then((result) => {
          const blob = new Blob([result], { type: "application/pdf" });

          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `${item.exam_code}_${item.year}_${item.college_code}_dsp-signed.pdf`
          );
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error("Tanvir! Download failed", error);
        });

      // this.$store
      //   .dispatch("downloadExamWiseDescriptiveRollSheet", param)
      //   .then((result) => {
      //     //console.log("ds roll sheet", result);
      //     setTimeout(function () {
      //       var fileLink = document.createElement("a");
      //       fileLink.href = result;
      //       //fileLink.setAttribute("download", "file.pdf");
      //       fileLink.setAttribute("target", "_blank");
      //       document.body.appendChild(fileLink);
      //       fileLink.click();
      //     }, 1000);
      //   });
    },

    //this is the one
    // downloadAdmit(item, inst_no) {
    //   console.log("down method", item);
    //   var param = {
    //     exam_code: item.exam_code,
    //     subject_code: item.subject_code,
    //     exam_year: item.year,
    //     college_code: item.college_code,
    //     module_name: "College",
    //     adm_installment_no: inst_no
    //   };

    //   this.$store.dispatch("downloadAdmitCollegewiseCollegePanel", param).then(result => {
    //     console.log("in then admit", result);
    //     result.forEach(url => {
    //       setTimeout(function() {
    //         var fileLink = document.createElement("a");
    //         fileLink.href = url;
    //         fileLink.setAttribute("target", "_blank");
    //         document.body.appendChild(fileLink);
    //         fileLink.click();
    //       }, 1000);
    //     });
    //   });
    // },

    // this is three
    // downloadAdmit(item, inst_no) {
    //   console.log("Downloading admit card for:", item);

    //   const param = {
    //     exam_code: item.exam_code,
    //     subject_code: item.subject_code,
    //     exam_year: item.year,
    //     college_code: item.college_code,
    //     module_name: "College",
    //     adm_installment_no: inst_no,
    //   };

    //   this.$store
    //     .dispatch("downloadAdmitCollegewiseCollegePanel", param)
    //     .then((result) => {
    //       result.forEach((url, index) => {
    //         setTimeout(() => {
    //           fetch(url)
    //             .then((res) => res.blob())
    //             .then((blob) => {
    //               const fileURL = window.URL.createObjectURL(blob);
    //               const fileName = url.split("/").pop();
    //               const aTag = document.createElement("a");
    //               aTag.href = fileURL;
    //               aTag.setAttribute("download", fileName);
    //               document.body.appendChild(aTag);
    //               aTag.click();
    //               aTag.remove();
    //               window.URL.revokeObjectURL(fileURL);
    //             });
    //         }, index * 1000);
    //       });
    //     })
    //     .catch((error) => {
    //       console.error("Error downloading admit cards:", error);
    //       if (this.$toast && typeof this.$toast.error === "function") {
    //         this.$toast.error("Failed to download admit card(s).");
    //       }
    //     });
    // },

    //this is two
    // downloadAdmit(item, inst_no) {
    //   const param = {
    //     exam_code: item.exam_code,
    //     subject_code: item.subject_code,
    //     exam_year: item.year,
    //     college_code: item.college_code,
    //     module_name: "College",
    //     adm_installment_no: inst_no,
    //   };

    //   this.$store
    //     .dispatch("downloadAdmitCollegewiseCollegePanel", param)
    //     .then((urls) => {
    //       console.log("📦 Admit card URLs:", urls);

    //       if (Array.isArray(urls) && urls.length) {
    //         urls.forEach(async (url) => {
    //           const fileName = url.split("/").pop();

    //           try {
    //             const response = await fetch(url);
    //             const blob = await response.blob();

    //             const downloadLink = document.createElement("a");
    //             downloadLink.href = URL.createObjectURL(blob);
    //             downloadLink.setAttribute("download", fileName);
    //             document.body.appendChild(downloadLink);
    //             downloadLink.click();
    //             document.body.removeChild(downloadLink);
    //             URL.revokeObjectURL(downloadLink.href);
    //           } catch (error) {
    //             console.error("Download failed:", error);
    //           }
    //         });
    //       } else {
    //         console.warn("⚠️ No URLs found to download.");
    //       }
    //     });
    // },

    // downLoadrollDescriptive(item, inst_no) {
    //   let param = {};
    //   param.college_code = item.college_code;
    //   param.center_code = item.center_code;
    //   param.subject_code = item.subject_code;
    //   param.exam_initiate_id = item.exam_initiate_id;
    //   param.exam_code = item.exam_code;
    //   param.year = item.year;
    //   param.adm_installment_no = inst_no;

    //   this.$store
    //     .dispatch("downloadExamWiseDescriptiveRollSheet", param)
    //     .then((result) => {

    //       setTimeout(function () {
    //         var fileLink = document.createElement("a");
    //         fileLink.href = result;

    //         fileLink.setAttribute("target", "_blank");
    //         document.body.appendChild(fileLink);
    //         fileLink.click();
    //       }, 1000);
    //     });
    // },

    // resolve(response.data.meta);
    fetchAdmitCardDataBySubject() {
      this.loading = true;
      this.setLimit();
      this.$store
        .dispatch("fetchCollegeAdmitCardDataBySubject", this.searchParam)
        .then((data) => {
          this.loading = false;
          this.sl_count = data.from;
          this.pagination.totalItems = data.total;
        });
    },

    processAdmitCardGenColWise() {
      // console.log("--->", this.searchParam.exam_code);

      if (this.searchParam.exam_code == null || this.searchParam.year == null) {
        //console.log("in if --> Null");
        this.$store.commit("SET_SNACKBAR", {
          msg: "Exam or Year not selected ",
          color: "red",
        });
      } else {
        //console.log("in else --> Not Null");
        this.$root
          .$confirm("Are you sure that you want to Generate?")
          .then((confirm) => {
            if (confirm) {
              this.$store
                .dispatch("generateAdmitCardColwise", this.searchParam)
                .then(() => {
                  //console.log("success");
                });
            }
          });
      }
    },
    onStartedDownload(id) {
      //console.log(`Started downloading: ${id}`);
    },

    onFailed(error) {
      //console.log(`Download failed: ${error}`);
    },
    viewAdmitCard(item) {
      this.$refs.refAdmitCard.searchParam.exam_code = item.exam_code;
      this.$refs.refAdmitCard.searchParam.college_code = item.college_code;
      this.$refs.refAdmitCard.searchParam.year = item.year;
      this.$refs.refAdmitCard.searchParam.session_year = item.session;
      this.$refs.refAdmitCard.admitGenMode = false;
      this.$refs.refAdmitCard.centerMode = false;
      this.$refs.refAdmitCard.collegeMode = false;
      this.$refs.refAdmitCard.paperMode = false;
      this.$refs.refAdmitCard.regMode = true;
      this.$refs.refAdmitCard.searchAdmitCardList();
      this.admitCardDialogStatus = !this.admitCardDialogStatus;
    },
    viewAdmitCardColDetails(item) {
      //console.log(item);
      // this.$store.commit("SET_ADMIT_CARD_CURRENT_ITEM_DETAILS", item);
      this.currentSubject = item;
      this.currentSubject.center_code = item.center_code;
      this.admitCardDialogStatus = true;
    },
    close() {
      this.admitCardDialogStatus = false;
      this.$store.commit("UNSET_ADMIT_CARD_LIST_DATA");
      this.$store.commit("UNSET_LOADING");
    },
    SetCurrentExam(obj) {
      this.$store.commit("SET_LOGGEDIN_EXAM", {
        code: obj.exam_code,
      });
      this.$store.commit("SET_LOGGEDIN_YEAR", {
        year: obj.exam_year,
        exam_year: obj.exam_year,
      });
      this.$store.commit("SET_EXAM_INITIATE_ID", obj.id);
    },
    searchList() {
      //console.log("ce", this.searchParam);
      this.fetchAdmitInstallmentDatalist();
      let activityLoad = {
        exam_code: this.searchParam.exam_code,
        exam_year: this.searchParam.year,
      };
      this.$store
        .dispatch("getExamActivityStatusData", this.searchParam)
        .then((response) => {
          console.log("activity", response.admitCardPublished);
          if (response.admitCardPublished) {
            //this.fetchAdmitCardDataBySubject();
            this.setLimit();
            this.$store
              .dispatch("fetchCollegeAdmitCardDataBySubject", this.searchParam)
              .then((data) => {
                this.$store.dispatch(
                  "fetchCollegeIndividualSpecialAdmitCard",
                  this.searchParam
                );
                this.loading = false;
                this.sl_count = data.from;
                this.pagination.totalItems = data.total;
              });
          } else {
            this.$store.commit("UNSET_ADMIT_CARD_DATA_BY_SUBJECT");
          }
        })
        .catch((error) => {
          console.log("uniuerror", error.response);
        });
    },
  },
  watch: {
    pagination() {
      //this.fetchAdmitCardDataBySubject();
    },
    currentCollege(val) {
      //console.log("sppsps");
      this.searchParam.center_code = val.center_code;
      this.searchParam.college_code = val.college_code;
      //this.fetchAdmitCardDataBySubject();
    },
  },

  mounted() {
    this.searchParam.college_code = this.college.college_code;
    this.$store.commit("UNSET_ADMIT_CARD_DATA_BY_SUBJECT");
  },
};
</script>
<style scoped>
.mycustomExpansionPanel .v-expansion-panel__header {
  border: 1px solid rgb(255, 255, 255) !important;
}

.Male {
  background-color: #386c8e;
  color: white;
}

.Female {
  background-color: #ad2da3;
  color: white;
}

.text-center {
  text-align: center;
}

.margin-auto {
  margin: auto;
}

.w-250 {
  width: 200px;
  height: 40px;
  font-size: 10px !important;
  padding: 3px 5px;
}

td,
tr {
  background-color: white !important;
}
</style>
